import React, { useMemo, useState } from "react";
import QRCode from "react-qr-code";
import { Container, ValueRow } from "./styles";
import Button from "../Button";

type QRCodeWithCopyProps = {
  value: string;
};

const QRCodeWithCopy: React.FC<QRCodeWithCopyProps> = ({ value }) => {
  const [copied, setCopied] = useState(false);
  const windowWidth = useMemo(() => window.innerWidth, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
    }
  };

  const getQRCodeSize = () => {
    if (windowWidth < 480) return 180; // mobile
    if (windowWidth < 768) return 250; // tablet
    return 350; // desktop
  };

  return (
    <Container>
        <QRCode value={value} size={getQRCodeSize()}/>
      
      <ValueRow>
        <span>{value}</span>
        <Button
          button={{ type: 'button', id: "button-action-address" }}
          onClick={handleCopy}
          atributes={{
            buttonType: 'outline',
            borderColor: 'var(--primary)',
            textColor: '#FFF',
            background: 'var(--primary)',
            textSize: '16px',
            padding: '12px 2px',
            disableWitdthfixed: false,
            textColorHover: '#FFF',
            borderColorHover: 'var(--primary)',
          }}
        >
          {copied ? "Copiado!" : "Copiar"}
        </Button>
      </ValueRow>
    </Container>
  );
};

export default QRCodeWithCopy;
